const shortenName = (fullName) => {
  if (!fullName || typeof fullName !== "string") return "";

  if (["[Automatic]", "Prospect [iOS App]"].includes(fullName)) {
    return fullName;
  }

  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 0) return "";

  const firstInitial = parts[0][0].toUpperCase() + ".";
  const rest = parts.slice(1).join(" ");

  return rest ? `${firstInitial} ${rest}` : `${firstInitial}`;
};

export default shortenName;
